import './header-user-menu.scss';

import { Dropdown, type MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {
  userName: string;
  profileInitial: string;
  menuItems: MenuProps['items'];
}

const HeaderUserMenu: React.FC<IProps> = ({
  userName,
  profileInitial,
  menuItems
}) => {
  const { t } = useTranslation();

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomRight"
    >
      <button
        type="button"
        className="header-user-menu__avatar"
        aria-label={userName || t('layout.userMenu.profileAria')}
      >
        {profileInitial}
      </button>
    </Dropdown>
  );
};

export default HeaderUserMenu;
